import { render, staticRenderFns } from "./TabReservations.vue?vue&type=template&id=283d0f49&"
import script from "./TabReservations.vue?vue&type=script&lang=ts&"
export * from "./TabReservations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports